module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dFONy"))).then(() => module.bundle.root('dsisd'));